import React from 'react';

/** Microsoft Outlook brand mark */
export const OutlookIcon = ({ className = 'h-5 w-5', title = 'Outlook' }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden={title ? undefined : true}
    role={title ? 'img' : 'presentation'}
  >
    {title ? <title>{title}</title> : null}
    <path fill="#0A2767" d="M15.545 12.047v7.953c0 .55-.45 1-1 1H2c-.55 0-1-.45-1-1V7.5l7.273 4.547a1.2 1.2 0 0 0 1.254 0L15.545 7.5v4.547z" />
    <path fill="#0364B8" d="M23 7.5v10.5c0 .55-.45 1-1 1h-7.455v-7z" />
    <path fill="#28A8EA" d="M14 1H3C1.9 1 1 1.9 1 3v5.5l6.8 4.25c.5.31 1.12.31 1.62 0L16.2 5.4 14 1z" />
    <path fill="#0078D4" d="M23 7.5H15.545L9.42 11.75c-.5.31-1.12.31-1.62 0L1 7.5V6c0-1.1.9-2 2-2h20c1.1 0 2 .9 2 2v1.5h-2z" />
    <circle fill="#fff" cx="7.5" cy="6.75" r="2.75" />
    <ellipse fill="#28A8EA" cx="7.5" cy="6.75" rx="1.55" ry="1.7" />
  </svg>
);

/** Official GitHub Octocat mark */
export const GitHubIcon = ({ className = 'h-5 w-5', title = 'GitHub' }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden={title ? undefined : true}
    role={title ? 'img' : 'presentation'}
  >
    {title ? <title>{title}</title> : null}
    <path
      fill="currentColor"
      d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12"
    />
  </svg>
);
